<template>
  <el-select
          v-if="schema&&!recordId"
          v-model="val"
          :multiple="multiple"
          :placeholder="placeholder"
          :size="size"
          filterable
          :clearable="clearable"
          :remote="schema&&!recordId"
          :remote-method="loadRowOptions"
          @visible-change="focus"
          @change="onChange"
          @clear="onClear"
          @input="handleInput"
          :loading="loading"
  >
    <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
    ></el-option>
  </el-select>
  <el-select
          v-else
          v-model="val"
          :multiple="multiple"
          :placeholder="placeholder"
          :filterable="filterable"
          clearable
          :size="size"
          @change="onChange"
          @clear="onClear"
          @input="handleInput"
  >
    <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
    ></el-option>
  </el-select>
</template>


<script>
export default {
    props: {
        value: [String, Number, Array],
        multiple: Boolean,
        labelField: String,
        labelRender: Function,
        schema: String,
        recordId: String,
        column: String,
        query: Object,
        clearable: {
            type: Boolean,
            default: true
        },
        filterable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        expand: {
            type: String,
            default: ''
        },
        size: String
    },
    data() {
        return {
            val: this.value,
            loading: false,
            options: []
        };
    },
    watch: {
        value: function (val) {
            this.val = val;
        }
    },
    beforeMount() {
        this.loadOptions();
    },
    methods: {
        focus() {
            if (this.isArrayColumnOptions()) {
                this.loadArrayOptions();
            } else {
                this.loadRowOptions();
            }
        },
        handleInput() {
            this.$emit('input', this.val);
        },
        loadOptions() {
            if (this.isArrayColumnOptions()) {
                this.loadArrayOptions();
            } else {
                this.loadRowOptions();
            }
        },
        isArrayColumnOptions() {
            return this.recordId && this.column;
        },
        option(item) {
            if (this.labelRender) {
                return {
                    label: this.labelRender(item),
                    value: item.id,
                    item: item
                };
            }
            return {
                label: this.labelField ? item[this.labelField] : item,
                value: this.labelField ? item.id : item,
                item: item
            };
        },
        loadArrayOptions() {
            this.$ox
                .table(this.schema)
                .getRecord(this.recordId)
                .then(
                    r => {
                        let arr = r[this.column];
                        this.options = arr.map(i => this.option(i));
                    },
                    () => {
                        this.options = [];
                    }
                );
        },
        loadRowOptions(queryString = '') {
            this.loading = true;
            let query = new window.BaaS.Query();
            if (queryString.trim() !== '') {
                query.contains(this.labelField, queryString);
            }
            if(this.query){
                query = window.BaaS.Query.and(query, this.query);
            }
            this.$ox
                .service(this.schema)
                .find(query, {expand: this.expand, pageSize:100})
                .then(
                    data => {
                        this.loading = false;
                        this.options = data.objects.map(i => this.option(i));
                    },
                    () => {
                        this.loading = false;
                        this.options = [];
                    }
                );
        },
        restore(id) {
            if (!id) {
                this.loadOptions();
                return false;
            }
            let found = this.options.find(i => {
                return id === i.value;
            });
            if (!found) {
                this.$ox
                    .table(this.schema)
                    .getRecord(id)
                    .then(
                        record => {
                            this.options = [this.option(record)];
                            this.val = id;
                            this.$emit('input', this.val);
                        },
                        () => {
                            this.options = [
                                {
                                    value: 0,
                                    label: '找不到记录，或已被删除',
                                    item: null
                                }
                            ];
                            this.val = 0;
                            this.$emit('input', this.val);
                        }
                    );
            } else {
                this.val = id;
                this.$emit('input', this.val);
            }
        },
        restoreMulti(ids) {
            if (!ids) {
                this.loadOptions();
                return false;
            }
            this.$ox
                .table(this.schema)
                .query({where: {id: {$in: ids}}})
                .then(
                    res => {
                        this.options = res.objects.map(record =>
                            this.option(record)
                        );
                        this.val = ids;
                        this.$emit('input', this.val);
                    },
                    () => {
                        this.options = [
                            {
                                value: 0,
                                label: '找不到记录，或已被删除',
                                item: null
                            }
                        ];
                        this.val = 0;
                        this.$emit('input', this.val);
                    }
                );
        },
        onClear() {
            this.loadOptions();
            this.$emit('clear');
        },
        onChange(val) {
            let item = this.options.find(i => {
                return i.value === val;
            });
            this.$emit('change', val, item);
        },
        selected(cb) {
            let values = [].concat(this.value);
            this.$ox
                .table(this.schema)
                .query({where: {id: {$in: values}}, limit: 100})
                .then(
                    res => {
                        return cb(values, res.objects);
                    },
                    err => {
                        throw new Error(err);
                    }
                );
        }
    }
};
</script>
